import _defineProperty from "/app/node_modules/.pnpm/next@13.5.3_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { combineReducers } from '@reduxjs/toolkit';
import { all } from 'redux-saga/effects';
import checkoutSagas from './sagas';
import shippingSagas from './shipping/sagas';
import paymentSagas from './payment/sagas';
import * as constants from './constants';
import * as checkoutStatelessActions from './actions';
import * as checkoutSelectors from './selectors';
import checkoutReducer, { actions as checkoutActions } from './slice';
import shippingReducer, { actions as shippingActions, selectors as shippingSelectors, statelessActions as shippingStatelessActions } from './shipping';
import paymentReducer, { actions as paymentActions, selectors as paymentSelectors, statelessActions as paymentStatelessActions } from './payment';

const actions = _objectSpread(_objectSpread(_objectSpread({}, checkoutActions), shippingActions), paymentActions);

const reducer = combineReducers({
  checkout: checkoutReducer,
  shipping: shippingReducer,
  payment: paymentReducer
});

const selectors = _objectSpread(_objectSpread(_objectSpread({}, checkoutSelectors), shippingSelectors), paymentSelectors);

const statelessActions = _objectSpread(_objectSpread(_objectSpread({}, checkoutStatelessActions), paymentStatelessActions), shippingStatelessActions);

function* sagas() {
  yield all([checkoutSagas(), shippingSagas(), paymentSagas()]);
}

export { constants, statelessActions, actions, selectors, sagas };
export * from './types';
export const plug = {
  [constants.stateName]: reducer
};
export default reducer;